var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22806_174311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.212158,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22806_174311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69552 10.4556L10.5993 8.59028C10.742 8.49973 10.8133 8.3739 10.8133 8.21278C10.8133 8.05167 10.742 7.9254 10.5993 7.83395L7.69552 5.96862C7.54596 5.86606 7.39252 5.85784 7.23518 5.94395C7.07796 6.03006 6.99935 6.16434 6.99935 6.34678V10.0775C6.99935 10.2599 7.07796 10.3942 7.23518 10.4803C7.39252 10.5664 7.54596 10.5582 7.69552 10.4556ZM8.50052 14.5455C7.62452 14.5455 6.80113 14.3792 6.03035 14.0468C5.25957 13.7143 4.58913 13.2632 4.01902 12.6933C3.4489 12.1234 2.99752 11.4532 2.66485 10.6828C2.33229 9.91234 2.16602 9.08917 2.16602 8.21328C2.16602 7.33728 2.33224 6.5139 2.66468 5.74312C2.99713 4.97234 3.44829 4.3019 4.01818 3.73178C4.58807 3.16167 5.25824 2.71028 6.02868 2.37762C6.79913 2.04506 7.62229 1.87878 8.49818 1.87878C9.37418 1.87878 10.1976 2.04501 10.9683 2.37745C11.7391 2.7099 12.4096 3.16106 12.9797 3.73095C13.5498 4.30084 14.0012 4.97101 14.3338 5.74145C14.6664 6.5119 14.8327 7.33506 14.8327 8.21095C14.8327 9.08695 14.6665 9.91034 14.334 10.6811C14.0016 11.4519 13.5504 12.1223 12.9805 12.6925C12.4106 13.2626 11.7405 13.714 10.97 14.0466C10.1996 14.3792 9.3764 14.5455 8.50052 14.5455ZM8.49935 13.5455C9.98824 13.5455 11.2493 13.0288 12.2827 11.9955C13.316 10.9621 13.8327 9.70101 13.8327 8.21212C13.8327 6.72323 13.316 5.46212 12.2827 4.42878C11.2493 3.39545 9.98824 2.87878 8.49935 2.87878C7.01046 2.87878 5.74935 3.39545 4.71602 4.42878C3.68268 5.46212 3.16602 6.72323 3.16602 8.21212C3.16602 9.70101 3.68268 10.9621 4.71602 11.9955C5.74935 13.0288 7.01046 13.5455 8.49935 13.5455Z",
    fill: "#4B73EC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.9d9ca8cdbcd958abfa9d6ebeb36de7f7.svg";
export { ForwardRef as ReactComponent };